import React, { useState } from "react";
import PlayerImage from "../../components/PlayerImage";
import { FantasyPlayer } from "../../models/FantasyPlayer";
import { FantasyRarity } from "../../models/FantasyRarity";
import styles from "./PredictPlayerSlot.module.css";
//import styles from "./PlayerSlot.module.css";
import useLocalStorage from "use-local-storage";


interface PredictPlayerSlotProps {
  player: FantasyPlayer;
}

const PredictPlayerSlot: React.FC<PredictPlayerSlotProps> = ({ player }) => {
  const [flipped, setFlipped] = useState(false);
  const [isDark] = useLocalStorage<boolean>('isDark', false);

  const handleFlip = () => setFlipped(!flipped);

  // Get the correct rarity class
  const getRarityClass = () => {
    switch (player.rarity) {
      case FantasyRarity.ShinyGold:
        return styles.ShinyGold;
      case FantasyRarity.Gold:
        return styles.Gold;
      case FantasyRarity.ShinySilver:
        return styles.ShinySilver;
      case FantasyRarity.Silver:
        return styles.Silver;
      case FantasyRarity.Bronze:
        return styles.Bronze;
      default:
        return styles.Gray; // Default class for unknown rarities
    }
  };

  // Check if the card is shiny
  const isShiny = () => {
    return player.rarity === FantasyRarity.ShinyGold || player.rarity === FantasyRarity.ShinySilver;
  };

  return (
    <div
      className={`card ${styles.flipCard} ${getRarityClass()} ${
        flipped ? styles.flipped : ""
      } ${isDark ? styles.darkCard : ""} ${isShiny() ? styles.shinyEffect : ""}`}
      style={{
        minHeight: "290px",
        maxWidth: "220px",
        maxHeight: "290px",
        cursor: "pointer", // Indicate clickable card
      }}
      onClick={handleFlip}
    >
      <div className={styles.flipCardInner}>
        {/* Front Side */}
        <div className={`${styles.flipCardFront} ${isDark ? styles.darkMode : ""}`}>
          <div className={styles["card-body"]}>
            <div className={styles.playerImage}>
              <PlayerImage id={player.account.steamID} width={180} />
            </div>
            <div className={styles["text-center"]}>
              <h5 className={styles.playerName}>{player.account.playerName}</h5>
            </div>
          </div>
        </div>

        {/* Back Side */}
        <div className={`${styles.flipCardBack} ${isDark ? styles.darkMode : ""}`}>
          <h5 className="mb-2">{player.account.playerName}</h5>
          <ul className="list-unstyled text-center mb-1">
            <li>
              <strong>Rating:</strong>{" "}
              {player.stats?.hltv2Rating
                ? player.stats.hltv2Rating.toFixed(2)
                : "N/A"}
            </li>
            <li>
              <strong>K/D:</strong>{" "}
              {player.stats?.kd ? player.stats.kd.toFixed(2) : "N/A"}
            </li>
            <li>
              <strong>First Kills:</strong> {player.stats?.fk ?? "N/A"}
            </li>
            <li>
              <strong>KAST:</strong>{" "}
              {player.stats?.kast ? player.stats.kast.toFixed(2) : "N/A"}%
            </li>
            <li>
              <strong>ADR:</strong>{" "}
              {player.stats?.adr ? player.stats.adr.toFixed(2) : "N/A"}
            </li>
            <li>
              <strong>HS:</strong>{" "}
              {player.stats?.hs ? player.stats.hs.toFixed(2) : "N/A"}%
            </li>
            <li>
              <strong>Faceit Elo:</strong> {player.account.faceitElo ?? "N/A"}
            </li>
          </ul>
          <div className={styles["card-footer"]}>
            <a
              href={`https://powerstats.dk/player/${player.account.steamID}`}
              target="_blank"
              rel="noopener noreferrer"
              className={`btn ${isDark ? 'btn-outline-light' : 'btn-primary'} w-100`}
            >
              View Profile
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PredictPlayerSlot;